// src/components/ProtectedRoute.js
import React,{useEffect} from "react";
import { Navigate ,useLocation,useNavigate} from "react-router-dom";
import { useSelector } from "react-redux";
import { homePagePath } from "../../constant";


const ProtectedRoute = ({ children, requiredRole }) => {
  const { isLoggedIn, role, providerTypes } = useSelector(
    (state) => state.auth
  );
//    const location = useLocation();
//   const navigate = useNavigate();


// console.log("location.pathname ",location.pathname )
// useEffect(() => {
//   // Check if this is the first render after a full page load
//   const navEntries = performance.getEntriesByType("navigation");
//   const isHardReload =
//     navEntries.length > 0 && navEntries[0].type === "reload";


//   if (isLoggedIn && role === "customer" && isHardReload) {
//     navigate("/dashboard", { replace: true });
//   }
//   // 👇 Run only once on mount, not on every route change
//   // eslint-disable-next-line react-hooks/exhaustive-deps
// }, []);




  // const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);


  // return isLoggedIn ? children : <Navigate to="/" />;
  if (!isLoggedIn) {
    return <Navigate to={"/401"} />;
  }
  if (requiredRole === "provider" && role === "provider") {
    return children; // Access granted to providers
  }
  // Admin check: role string contains "admin" (case-insensitive)
  // This supports "admin", "Thurentadmin", etc.
  if (requiredRole === "admin" && (role || "").toLowerCase().includes("admin")) {
    return children; // Access granted to admins
  }
  // Also allow providers to access admin routes (they get 403 from API if not actually admin)
  if (requiredRole === "admin" && role === "provider") {
    return children;
  }


  if (requiredRole === "customer" && role === "customer") {
    return children; // Access granted to customers
  }
  // Logged in but role mismatch → show unauthorized (401)
  // return children
  return <Navigate to={homePagePath} />;
};


export default ProtectedRoute;



